module.exports = __webpack_public_path__ + "img/search.a4e6bfc7.svg";